import { render, staticRenderFns } from "./SH045ShippingGiftSettings.vue?vue&type=template&id=1d12ddb7&scoped=true&"
import script from "./SH045ShippingGiftSettings.vue?vue&type=script&lang=js&"
export * from "./SH045ShippingGiftSettings.vue?vue&type=script&lang=js&"
import style0 from "./SH045ShippingGiftSettings.vue?vue&type=style&index=0&id=1d12ddb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12ddb7",
  null
  
)

export default component.exports